import PropTypes from 'prop-types';
import classes from './ThumbnailFile.module.css';
import ThumbnailPDF from 'Components/Atoms/ThumbnailPDF/ThumbnailPDF';

export default function ThumbnailFilePDF({ url }) {
    return (
        <div className={classes.page}>
            <ThumbnailPDF url={url} />
        </div>
    );
}

ThumbnailFilePDF.propTypes = {
    url: PropTypes.string.isRequired,
};
